import React from 'react';
import { formatToJSTDateTime, parseUtcDate } from '../../utils/dateFormatter.js';

// 推薦の実行日時の文言 (画面レイアウト_SCR-M-001.md §4.2 DP-M-015。PM 確定 2026-10-03、Issue #710)
export const EXECUTED_AT_PREFIX = '推薦結果: ';
export const EXECUTED_AT_SUFFIX = ' に実行';

/**
 * 推薦の実行日時 (DP-M-015、Issue #710)。
 *
 * 推薦結果を実行からの経過時間を問わず表示するため (SCR-M-001 §6.1)、何日も前の結果が
 * 今日の結果に見えないよう、表示中の結果をいつ実行したかを出す。前回の結果を再利用した
 * 実行では再利用した結果の日時 (前回の実行の日時) になる——推薦を計算した日時を示す。
 * created_at が無い・解釈できないときは何も出さない (推薦結果は呼び出し側が出す)。
 *
 * @param {{createdAt?: string|null}} props - 表示中の推薦結果の created_at (UTC)
 */
function ResultExecutedAt({ createdAt }) {
    const date = parseUtcDate(createdAt);
    if (!date) return null;

    return (
        <p className="matching-result-executed-at">
            {EXECUTED_AT_PREFIX}
            <time dateTime={date.toISOString()} className="matching-result-executed-at-time">
                {formatToJSTDateTime(createdAt)}
            </time>
            {EXECUTED_AT_SUFFIX}
        </p>
    );
}

export default ResultExecutedAt;
